module.exports = __webpack_public_path__ + "static/media/team-illustration-2.816c3ca4.svg";